import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {ConfirmationService, LazyLoadEvent, MessageService, PrimeNGConfig} from 'primeng/api';
import {Constant} from '../util/constant';
import {SharedService} from '../web-services/shared.service';
import {ConstantService} from '../web-services/constant.service';
import {Labels} from '../util/labels';
import {BodyChartMasterService} from '../web-services/body-chart-master.service';
import {ListOfValuesService} from '../web-services/list-of-values.service';
import {UsersService} from '../web-services/users.service';
import {SessionService} from "../services/session.service";

declare var closeAddOverlaydiv: Function;
declare var closeSearchOverlaydiv: Function;
declare var openAddOverlaydiv: Function;

@Component(
    {
        selector: 'app-body-chart-master',
        templateUrl: './body-chart-master.component.html',
        styleUrls: ['./body-chart-master.component.css']
    })
export class BodyChartMasterComponent implements OnInit {
    public labels = Labels;
    formButton: string = this.translate(this.labels.btnAdd);
    submitted = false;
    selectedIndex = -1;
    updateBodyChartMasterId = null;
    listOfValuesList: any = [];
    usersList: any = [];
    bodyChartMasterList: any = [];
    bodyChartMasterSearch: FormGroup;
    clearSearchBtn = false;
    totalRecords;
    itemPerPage: number = Constant.ITEM_PER_PAGE;
    bodyChartMasterForm: FormGroup;
    constantList = [];
    pageNo: number = 0;
    onValueChange = true;

    showSearchDialog = false;
    showSearchBtn = false;
    showAddDialog = false;
    showAddBtn = false;
    editTag = false;
    disableColumn = false;
    passwordType = 'password';
    patientObj: any;


  addEditTitle = '';
    constructor(
        private bodyChartMasterServices: BodyChartMasterService, private listOfValuesServices: ListOfValuesService,
        private usersServices: UsersService, private primengConfig: PrimeNGConfig, private confirmation: ConfirmationService,
        private messageService: MessageService, private route: Router, private loader: NgxUiLoaderService,
        private constantService: ConstantService, private sharedService: SharedService, private sessionService: SessionService
    ) {
    };

    get addUpdateTitle() {
        return this.updateBodyChartMasterId == null ? this.translate(this.labels.btnAdd) : this.translate(this.labels.btnUpdate);
    }

    onClearSearch() {
        this.bodyChartMasterSearch.reset();
        this.selectedIndex = -1;
    }

    onSearch() {
        this.clearSearchBtn = true;
        this.countBodyChartMaster();
        this.findAllBodyChartMaster();
        closeSearchOverlaydiv();
    }

    startLoader() {
        this.loader.start();
        setTimeout(() => {
            this.loader.stop();
        }, 3000);
    }

    stopLoader() {
        this.loader.stop();
    }

    countBodyChartMaster() {
        this.bodyChartMasterServices.countBodyChartMaster(this.bodyChartMasterSearch.value).subscribe(res => {
            if (res['message'] == 'Success') {
                this.totalRecords = res['data'][0];
                this.findAllBodyChartMaster();
            } else {
                this.totalRecords = 0;
            }
        }, err => {
            console.error('err: ', err);
        });
    }

    onSubmit() {
        this.addUpdateBodyChartMaster(this.bodyChartMasterForm.value);
        this.submitted = false;
        this.onClearAdd();
    }

    onPageChnage(event: LazyLoadEvent) {
        this.itemPerPage = event.rows;
        this.pageNo = event.first / event.rows;
        this.findAllBodyChartMaster();
    }

    clearSearchResult() {
        this.clearSearchBtn = false;
        this.bodyChartMasterSearch.reset();
        this.countBodyChartMaster();
        // this.findAllBodyChartMaster();
    }

    addUpdateBodyChartMaster(bodyChartMaster) {
        this.startLoader();
        if (this.updateBodyChartMasterId == null) {
            this.bodyChartMasterServices.addBodyChartMaster(this.bodyChartMasterForm.value).subscribe(res => {
                if (res['message'] == 'Success') {
                    bodyChartMaster = res['data'][0];
                    this.bodyChartMasterList.push(bodyChartMaster);
                    this.messageService.add({
                                                severity: 'success',
                                                summary: this.translate(this.labels.entityNameBodyChartMaster) +
                                                    this.translate(this.labels.addedSuccessfully),
                                                // detail: this.translate(this.labels.entityNameBodyChartMaster)
                                            });
                    this.submitted = true;
                    this.showHideAddDialog();
                    this.countBodyChartMaster();
                } else {
                    console.error(res['documentation']);
                    this.stopLoader();
                }
            }, err => {
                console.error('err: ', err);
                this.stopLoader();
            });
        } else {
            bodyChartMaster.bodyChartMasterId = this.updateBodyChartMasterId;
            this.bodyChartMasterServices.updateBodyChartMaster(bodyChartMaster).subscribe(res => {
                if (res['message'] == 'Success') {
                    this.bodyChartMasterList[this.selectedIndex] = res['data'][0];
                    this.submitted = true;
                    this.messageService.add({
                                                severity: 'success',
                                                summary: this.translate(this.labels.entityNameBodyChartMaster) +
                                                    this.translate(this.labels.updatedSuccessfully),
                                                // detail: this.translate(this.labels.entityNameBodyChartMaster)
                                            });
                    this.showSearchBtn = false;
                    this.showAddBtn = false;
                    this.showSearchDialog = false;
                    this.showAddDialog = false;
                    this.editTag = false;
                    this.countBodyChartMaster();
                } else {
                    console.error(res['documentation']);
                    this.stopLoader();
                }
            }, err => {
                console.error('err: ', err);
                this.stopLoader();
            });
            this.updateBodyChartMasterId = null;
            this.onClearAdd();
            this.formButton = this.translate(this.labels.btnAdd);
        }
        // this.stopLoader();
    }

    translate(label) {
        return this.sharedService.verifyLabel(label, this.constantList);
    }

    getConstantList(formId) {
        this.constantService.getFormConstantsList(formId).subscribe(data => {
            if (data['statusCode'] == 200) {
                this.constantList = data['data'];
            } else {
                this.constantList = [];
            }
        });
    }

    ngOnInit() {
        this.addEditTitle = this.labels.btnAdd;
        this.findAllListOfValues();
        this.findAllUsers();
        this.findAllUsers();
        // this.findAllAppointments();
        this.bodyChartMasterForm = new FormGroup({
                                                     bodyPartId: new FormControl(),
                                                     patientId: new FormControl(),
                                                     expertId: new FormControl(),
                                                     appointmentId: new FormControl(),
                                                     userId: new FormControl(0, [Validators.required, Validators.min(0)]),
                                                 });
        this.bodyChartMasterSearch = new FormGroup({
                                                       bodyPartId: new FormControl(),
                                                       patientId: new FormControl(),
                                                       expertId: new FormControl(),
                                                       appointmentId: new FormControl(),
                                                       userId: new FormControl(),
                                                   });
        this.countBodyChartMaster();
        this.findAllBodyChartMaster();
        this.getConstantList(1234);
        this.primengConfig.ripple = true;
        this.clearSearchBtn = false;
        this.bodyChartMasterSearch.valueChanges.subscribe(data => {
            this.onValueChange = false;
        });

        this.patientObj = JSON.parse(this.sessionService.getSession('patientObj')) ;

    }

    findAllBodyChartMaster() {
        this.startLoader();
        this.bodyChartMasterServices.findAllBodyChartMaster(this.bodyChartMasterSearch.value, this.pageNo, this.itemPerPage).subscribe(
            res => {
                if (res['message'] == 'Success') {
                    this.bodyChartMasterList = res['data'];
                } else {
                    this.bodyChartMasterList = [];
                }
                this.stopLoader();
            }, err => {
                console.error('err: ', err);
                this.stopLoader();
            });
    }

    deleteByIdBodyChartMaster(bodyChartMasterId: number, index) {
        this.confirmation.confirm({
                                      message: this.translate(this.labels.DELETE_MSG), accept: () => {
                this.startLoader();
                this.bodyChartMasterServices.deleteByIdBodyChartMaster(bodyChartMasterId).subscribe(res => {
                    if (res['message'] == 'Success') {
                        this.bodyChartMasterList.splice(index, 1);
                        this.messageService.add({
                                                    severity: 'warn',
                                                    summary: this.translate(this.labels.entityNameBodyChartMaster) +
                                                        this.translate(this.labels.deletedSuccessfully),
                                                    detail: ''
                                                    // detail: this.translate(this.labels.entityNameBodyChartMaster)
                                                });
                        this.countBodyChartMaster();
                    } else {
                        console.error('error: ', res['documentation']);
                        this.startLoader();
                    }
                }, err => {
                    console.error('err: ', err);
                    this.stopLoader();
                });
            }
                                  });
    }

    loadBodyChartMasterToEdit(bodyChartMasterId: number, index) {
        this.addEditTitle = this.labels.btnEdit;
        let bodyChartMaster = this.bodyChartMasterList.find(x => x['bodyChartMasterId'] == bodyChartMasterId);
        this.submitted = null;
        this.formButton = this.translate(this.labels.btnEdit);
        this.updateBodyChartMasterId = bodyChartMaster['bodyChartMasterId'];
        this.selectedIndex = index;
        this.bodyChartMasterForm.controls['bodyPartId'].setValue(bodyChartMaster['bodyPartId']['bodyPartId']);
        this.bodyChartMasterForm.controls['patientId'].setValue(bodyChartMaster['patientId']['patientId']);
        this.bodyChartMasterForm.controls['expertId'].setValue(bodyChartMaster['expertId']['expertId']);
        this.bodyChartMasterForm.controls['appointmentId'].setValue(bodyChartMaster['appointmentId']['appointmentId']);
        this.bodyChartMasterForm.controls['userId'].setValue(bodyChartMaster['userId']);
        openAddOverlaydiv();
    }

    onClearAdd() {
        this.bodyChartMasterForm.reset();
        this.bodyChartMasterForm.markAsUntouched();
        this.updateBodyChartMasterId = null;
        closeAddOverlaydiv();
    }

    findAllListOfValues() {
        let temp = [];
        this.startLoader();
        this.listOfValuesServices.findAllListOfValues(null, null, null).subscribe(
            res => {
                if (res['message'] == 'Success') {
                    temp = res['data'];
                    for (let object of temp) {
                        let dropDown = {label: '', value: ''};
                        dropDown.value = object['listOfValuesId'];
                        dropDown.label = object['value'];
                        this.listOfValuesList.push(dropDown);
                    }
                } else {
                    this.listOfValuesList = [];
                }
                this.stopLoader();
            }, err => {
                console.error('err: ', err);
                this.stopLoader();
            });
    }

    findAllUsers() {
        let temp = [];
        this.startLoader();
        this.usersServices.findAllUsers(null, null, null).subscribe(
            res => {
                if (res['message'] == 'Success') {
                    temp = res['data'];
                    for (let object of temp) {
                        let dropDown = {label: '', value: ''};
                        dropDown.value = object['userId'];
                        dropDown.label = object['userName'];
                        this.usersList.push(dropDown);
                    }
                } else {
                    this.usersList = [];
                }
                this.stopLoader();
            }, err => {
                console.error('err: ', err);
                this.stopLoader();
            });
    }

    fieldReset(control) {
        return this.bodyChartMasterForm.get(control).reset();
    }

    diplayeIconInField(control) {
        return this.bodyChartMasterForm.get(control)?.valid;
    }

    inputFieldDanger(control) {
        return !this.bodyChartMasterForm.get(control)?.valid && this.bodyChartMasterForm?.get(control)?.touched;
    }

    onCloseAdd() {
        closeAddOverlaydiv();
        this.bodyChartMasterForm.reset();
    }

    onCloseSearch() {
        closeSearchOverlaydiv();
        this.bodyChartMasterSearch.reset();
    }

    refresh() {
        this.countBodyChartMaster();
    }

    onAddOverlayDiv() {
        openAddOverlaydiv();
        this.bodyChartMasterForm.reset();
    }
    // by ali
    showHideSearchDialog() {
        this.showSearchDialog = !this.showSearchDialog;
        this.showSearchBtn = this.showSearchDialog;
        this.showAddBtn = this.showSearchDialog;
    }

    showHideAddDialog() {
        if(!this.showAddDialog) {
            this.bodyChartMasterForm.reset();
        }
        this.addEditTitle = this.labels.btnAdd;
        this.showAddDialog = !this.showAddDialog;
        this.showAddBtn = this.showAddDialog;
        this.showSearchBtn = this.showAddDialog;
        this.editTag = false;
        this.updateBodyChartMasterId = null;
    }
}
